import React from 'react';
import { useLanguage } from '../i18n';

export default function LoginRequiredModal({
  open,
  onClose,
  onLogin,
  onRegister
}) {
  const { t } = useLanguage();

  if (!open) return null;

  return (
    <div className="modal-overlay">
      <div
        className="modal-content login-required-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="login-required-title"
      >
        <div className="modal-header">
          <h2 id="login-required-title">{t('loginRequiredTitle')}</h2>
          <button className="modal-close" onClick={onClose} aria-label="Close">×</button>
        </div>

        <div className="modal-body">
          <p className="message-text">
            {t('loginRequiredMessage')}
          </p>
        </div>

        <div className="modal-footer">
          <button
            className="btn btn-secondary"
            onClick={onClose}
          >
            {t('cancel')}
          </button>
          <button
            className="btn btn-register"
            onClick={onRegister}
          >
            {t('loginRequiredRegisterButton')}
          </button>
          <button
            className="btn btn-login"
            onClick={onLogin}
          >
            {t('loginRequiredLoginButton')}
          </button>
        </div>
      </div>

      <style>{`
        .login-required-modal {
          max-width: 500px;
          width: 90%;
        }

        .modal-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 16px 20px;
          border-bottom: 1px solid #e9ecef;
        }

        .modal-header h2 {
          margin: 0;
          font-size: 22px;
          font-weight: 700;
          color: #1f2937;
        }

        .modal-close {
          border: none;
          background: transparent;
          font-size: 24px;
          line-height: 1;
          cursor: pointer;
          color: #6b7280;
        }

        .modal-body {
          padding: 24px 20px;
        }

        .message-text {
          margin: 0;
          font-size: 16px;
          line-height: 1.6;
          color: #374151;
        }

        .modal-footer {
          display: flex;
          gap: 12px;
          justify-content: flex-end;
          padding: 16px 20px;
          border-top: 1px solid #e9ecef;
        }

        .btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-height: 42px;
          padding: 10px 22px;
          border: 1px solid transparent;
          border-radius: 8px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.15s ease;
          text-decoration: none;
          user-select: none;
        }

        .btn:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(0,0,0,0.12);
        }

        .btn-login {
          background: #0d6efd;
          border-color: #0d6efd;
          color: #fff;
        }
        .btn-login:hover { 
          background: #0b5ed7; 
          border-color: #0b5ed7; 
        }

        .btn-register {
          background: #198754;
          border-color: #198754;
          color: #fff;
        }
        .btn-register:hover { 
          background: #157347; 
          border-color: #157347; 
        }

        .btn-secondary {
          background: #e9ecef;
          color: #495057;
          border: 1px solid #ced4da;
        }
        .btn-secondary:hover {
          background: #dfe3e6;
          color: #3a4046;
          border-color: #c3c9cf;
        }

        @media (max-width: 768px) {
          .login-required-modal {
            max-width: 95%;
          }

          .modal-footer {
            flex-direction: column;
            align-items: stretch;
          }

          .modal-footer .btn {
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
}
